import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { AdminAddBrandFormComponent } from "../components";
import { AdminDefaultLayout } from "../layouts/adminDefaultLayout";

// const userFormData = [
//   {
//     name: '',
//     type: 'text',
//   },
//   {
//     email: '',
//     type: 'email',
//   },
// ];

const columns = [
  { header: "Name", propName: "name" },
  { header: "State", propName: "state" },
  // Add other columns as needed
];

const actions = [
  {
    name: "Edit",
    method: (item: any) => {
      /* handle edit */
    },
  },
  {
    name: "Delete",
    method: (item: any) => {
      /* handle delete */
      // MAKE A POP UP FOR ARE YOU SURE?
    },
  },
];

const users: any[] = [
  {
    name: "Jeeter",
    state: "CA",
    avatarUrl: "https://via.placeholder.com/600",
  },
  {
    name: "STIIIZY",
    state: "CA",
    avatarUrl: "https://via.placeholder.com/600",
  },
];

export const AdminBrandsComponent = () => {
  const [formOpen, setFormOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [inputs, setInputs] = useState({});
  // const validationFunction = (data: any) => {
  //   console.log('data', data);
  //   // anything in userFormData !== '' is valid
  // };
  const [editingBrand, setEditingBrand] = useState({});

  const handleFormButtonClick = () => {
    setFormOpen(!formOpen);
  };

  const handleBrandButtonClick = (e: any) => {
    console.log("opened form for editing", e);
    setIsEditing(true);
    setEditingBrand(e);
    setFormOpen(!formOpen);
  };

  const setReset = () => {
    if (isEditing) {
      //reset to defaults
      setEditingBrand({});
      setIsEditing(false);
      setFormOpen(!formOpen);
    } else {
      setFormOpen(!formOpen);
    }
  };
  return (
    <>
      <AdminDefaultLayout
        openForm={handleFormButtonClick}
        formButtonTitle="Brand"
        actions={actions}
        columns={columns}
        header={"Brands"}
        searchType="brand"
        onItemSelect={handleBrandButtonClick}
      ></AdminDefaultLayout>
      {/* <Modal show={formOpen} onHide={handleFormButtonClick}> */}
      <Modal show={formOpen} onHide={setReset} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>{isEditing ? "Edit Brand" : "Add Brand"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AdminAddBrandFormComponent
            closeForm={handleFormButtonClick}
            data={editingBrand}
            setInputs={setInputs}
            editing={isEditing}
            setReset={setReset}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};
